/**
 * FileStorage/constants.ts
 * desc: file storage module constants
 * note: the flag is shared with the navs and the custom-data hub, which gate their entries themselves
 */
export const FILE_STORAGE_FLAG = 'web.fileStorage.feature.enabled';

export const VIEW_MODES = { TABLE: 'table', GRID: 'grid' } as const;
export type ViewMode = typeof VIEW_MODES[keyof typeof VIEW_MODES];

// mirrors tier0-core's max-attachment-file-size (50MB); a larger upload is refused by the backend
export const MAX_UPLOAD_BYTES = 50 * 1024 * 1024;
